import Immutable from 'immutable';
import constants       from 'Constants.js';
import CustomBehaviorView from 'workflow/properties/main/CustomBehaviorView.js';

const behaviors = {

    'layout_frame': [
        {text: 'App is opened', behaviorKey: 'onOpen', mobileCompatible: true},
        {text: 'App submits data', behaviorKey: 'onSubmit', mobileCompatible: true},
        {text: 'App is closed', behaviorKey: 'onClose', mobileCompatible: true},
        {text: 'App receives external call', behaviorKey: 'onExternalCall', mobileCompatible: true},
        {text: 'App submitted successfully', behaviorKey: 'onSubmitSuccess', mobileCompatible: true},
        {text: 'App is translated', behaviorKey: 'onAppTranslation', mobileCompatible: true}
    ],

    // TODO Double-check. Should this exist? I don't think there are behaviors for behaviors frame
    'behaviors_frame': [
        {text: 'App is opened', behaviorKey: 'onOpen', mobileCompatible: true},
        {text: 'App submits data', behaviorKey: 'onSubmit', mobileCompatible: true},
        {text: 'App is closed', behaviorKey: 'onClose', mobileCompatible: true},
        {text: 'App receives external call', behaviorKey: 'onExternalCall', mobileCompatible: true},
        {text: 'App submitted successfully', behaviorKey: 'onSubmitSuccess', mobileCompatible: true}
    ],

    'reports_frame': [
        {text: 'Report is opened', behaviorKey: 'onOpen', mobileCompatible: true},
        {text: 'Report is refreshed', behaviorKey: 'onRefresh', mobileCompatible: true},
        {text: 'Report is closed', behaviorKey: 'onClose', mobileCompatible: true},
        {text: 'Report receives external call', behaviorKey: 'onExternalCall', mobileCompatible: true}
    ],

    'page_instance': [
        {text: 'Page is opened', behaviorKey: 'onOpen', mobileCompatible: true},
        {text: 'Page is closed', behaviorKey: 'onClose', mobileCompatible: true},
        {text: 'Page is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true}
    ],

    'control_text': [
        {text: 'Mouse moves over Text', behaviorKey: 'onMouseOver', mobileCompatible: false},
        {text: 'Mouse moves away from Text', behaviorKey: 'onMouseOut', mobileCompatible: false},
        {text: 'Text is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Text is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_small_text': [
        {text: 'Mouse moves over Small Text', behaviorKey: 'onMouseOver', mobileCompatible: false},
        {text: 'Mouse moves away from Small Text', behaviorKey: 'onMouseOut', mobileCompatible: false},
        {text: 'Small Text is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Small Text is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_large_heading': [
        {text: 'Mouse moves over Large Heading', behaviorKey: 'onMouseOver', mobileCompatible: false},
        {text: 'Mouse moves away from Large Heading', behaviorKey: 'onMouseOut', mobileCompatible: false},
        {text: 'Large Heading is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Large Heading is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_medium_heading': [
        {text: 'Mouse moves over Medium Heading', behaviorKey: 'onMouseOver', mobileCompatible: false},
        {text: 'Mouse moves away from Medium Heading', behaviorKey: 'onMouseOut', mobileCompatible: false},
        {text: 'Medium Heading is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Medium Heading is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_small_heading': [
        {text: 'Mouse moves over Small Heading', behaviorKey: 'onMouseOver', mobileCompatible: false},
        {text: 'Mouse moves away from Small Heading', behaviorKey: 'onMouseOut', mobileCompatible: false},
        {text: 'Small Heading is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Small Heading is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_picture': [
        {text: 'Mouse moves over Picture', behaviorKey: 'onMouseOver', mobileCompatible: false},
        {text: 'Mouse moves away from Picture', behaviorKey: 'onMouseOut', mobileCompatible: false},
        {text: 'Picture is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Picture is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_button': [
        {text: 'Button is pressed', behaviorKey: 'onButtonPressed', mobileCompatible: true},
        {text: 'Button is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],
    'control_clear_filter_button': [
        {text: 'Clear Filter Button is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_filter_input': [
        {text: 'Filter Input is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_submit_button': [
        {text: 'Submit Button is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_page_button': [
        {text: 'Page Button is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_play_form_button': [
        // PF-9868 Removed behavior 'Show App Button changes field data'
        // {text: 'Show App Button changes field data', behaviorKey: 'onChanged', mobileCompatible: false},
        {text: 'Show App Button is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_play_report_button': [
        {text: 'Show Report Button is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_group': [
        {text: 'Group changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Group is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Group is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_text_input': [
        {text: 'Text Input changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Key is pressed', behaviorKey: 'onKeyPress', mobileCompatible: true},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Text Input gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Text Input loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Text Input is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Text Input is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_multiple_text_input': [
        {text: 'Multiline Text Input changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Key is pressed', behaviorKey: 'onKeyPress', mobileCompatible: true},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Multiline Text Input gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Multiline Text Input loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Multiline Text Input is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Multiline Text Input is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_numeric_input': [
        {text: 'Numeric Input changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Key is pressed', behaviorKey: 'onKeyPress', mobileCompatible: true},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Numeric Input gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Numeric Input loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Numeric Input is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Numeric Input is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    // TODO Double-check: there is no key pressed, according to my ConstantsTypes.as and devle.perfectforms.com
    'control_date_input': [
        {text: 'Date Input changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        // {               text: 'Key is pressed',                 behaviorKey: 'onKeyPress' },
        {text: 'Date Input gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Date Input loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Date Input is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Date Input is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    // TODO Double-check: there is no key pressed, according to my ConstantsTypes.as and devle.perfectforms.com
    'control_time_input': [
        {text: 'Time Input changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        //{               text: 'Key is pressed',                 behaviorKey: 'onKeyPress' },
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Time Input gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Time Input loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Time Input is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Time Input is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_date_calendar': [
        {text: 'Date Calendar changes field data', behaviorKey: 'onChanged', mobileCompatible: false},
        {text: 'Date Calendar gains focus', behaviorKey: 'onFocus', mobileCompatible: false},
        {text: 'Date Calendar loses focus', behaviorKey: 'onBlur', mobileCompatible: false},
        {text: 'Date Calendar is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Date Calendar is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],

    // TODO Double-check: A tickbox group has no text or events according to my ConstantsTypes.as
    'control_checkbox_group': [
        {text: 'Group changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Group is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Group is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_checkbox': [
        {text: 'Checkbox changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Checkbox gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Checkbox loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Checkbox is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Checkbox is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    // TODO Double-check A radiobutton group has no text or events according to ConstantsTypes.as
    'control_radio_button_group': [
        {text: 'Group changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Group is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Group is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_radio_button': [
        {text: 'Radio Button changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Radio Button gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Radio Button loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Radio Button is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Radio Button is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_drop_down': [
        {text: 'Drop-Down changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Drop-Down gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Drop-Down loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Drop-Down is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Drop-Down is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_list': [
        {text: 'List changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'List gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'List loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'List is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'List is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_bullet_text': [
        {text: 'Mouse moves over Bullet Text', behaviorKey: 'onMouseOver', mobileCompatible: false},
        {text: 'Mouse moves away from Bullet Text', behaviorKey: 'onMouseOut', mobileCompatible: false},
        {text: 'Bullet Text is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Bullet Text is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_vertical_separator': [
        {text: 'Vertical Separator is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],

    'control_horizontal_separator': [
        {text: 'Horizontal Separator is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_sound': [
        {text: 'Sound starts', behaviorKey: 'onStart', mobileCompatible: false},
        {text: 'Sound ends', behaviorKey: 'onEnd', mobileCompatible: false},
        {text: 'Sound is created', behaviorKey: 'onCreate', mobileCompatible: false}
    ],

    'control_movie': [
        {text: 'Movie starts', behaviorKey: 'onStart', mobileCompatible: false},
        {text: 'Movie ends', behaviorKey: 'onEnd', mobileCompatible: false},
        {text: 'Movie is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Movie is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],

    'control_link': [
        {text: 'Link is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Link is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_progress_bar': [
        {text: 'Progress Bar is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Progress Bar is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_timer': [
        {text: 'Timer changes field data', behaviorKey: 'onChanged', mobileCompatible: false},
        {text: 'Timer starts', behaviorKey: 'onStart', mobileCompatible: false},
        {text: 'Timer ends', behaviorKey: 'onEnd', mobileCompatible: false},
        {text: 'Timer makes interval step', behaviorKey: 'onTimer', mobileCompatible: false},
        {text: 'Timer is created', behaviorKey: 'onCreate', mobileCompatible: false}
    ],

    'control_print_button': [
        {text: 'Print Button is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_captcha': [
        {text: 'Captcha is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_mask_text_input': [
        {text: 'Mask Text Input changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Key is pressed', behaviorKey: 'onKeyPress', mobileCompatible: true},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Mask Text Input gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Mask Text Input loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Mask Text Input is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Mask Text Input is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_numeric_stepper': [
        {text: 'Numeric Stepper changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Numeric Stepper gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Numeric Stepper loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Numeric Stepper is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Numeric Stepper is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_password_input': [
        {text: 'Password Input changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Key is pressed', behaviorKey: 'onKeyPress', mobileCompatible: true},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Password Input gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Password Input loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Password Input is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Password Input is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_file_attachment': [
        {text: 'File Attachment changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'File Attachment is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'File Attachment is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_image_input': [
        {text: 'Image Import changes field data', behaviorKey: 'onChanged', mobileCompatible: false},
        {text: 'Image Import is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Image Import is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],

    'control_websignature': [
        {text: 'Web Signature changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Web Signature is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Web Signature is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_vertical_slider': [
        {text: 'Vertical Slider changes field data', behaviorKey: 'onChanged', mobileCompatible: false},
        {text: 'Vertical Slider gains focus', behaviorKey: 'onFocus', mobileCompatible: false},
        {text: 'Vertical Slider loses focus', behaviorKey: 'onBlur', mobileCompatible: false},
        {text: 'Vertical Slider is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Vertical Slider is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],

    'control_horizontal_slider': [
        {text: 'Horizontal Slider changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Horizontal Slider gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Horizontal Slider loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Horizontal Slider is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Horizontal Slider is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    'control_table': [
        {text: 'Table changes field data', behaviorKey: 'onChanged', mobileCompatible: true},
        {text: 'Row is added', behaviorKey: 'onRowAdd', mobileCompatible: true},
        {text: 'Row is deleted', behaviorKey: 'onRowDelete', mobileCompatible: true},
        {text: 'Row is added or deleted', behaviorKey: 'onRowsChanged', mobileCompatible: true},
        {text: 'Row gains focus', behaviorKey: 'onRowFocus', mobileCompatible: true},
        {text: 'Row loses focus', behaviorKey: 'onRowBlur', mobileCompatible: true},
        {text: 'Table gains focus', behaviorKey: 'onFocus', mobileCompatible: true},
        {text: 'Table loses focus', behaviorKey: 'onBlur', mobileCompatible: true},
        {text: 'Table is clicked', behaviorKey: 'onMouseClick', mobileCompatible: true},
        {text: 'Table is shown', behaviorKey: 'onCreate', mobileCompatible: true}
    ],

    //columns
    'buttonColumn': [
	    {text: 'Button is pressed', behaviorKey: 'onButtonPressed'}
    ],

	'checkboxColumn': [
	    {text: 'Checkbox changes field data', behaviorKey: 'onChanged'},
        {text: 'Checkbox gains focus', behaviorKey: 'onFocus'},
        {text: 'Checkbox loses focus', behaviorKey: 'onBlur'},
        {text: 'Checkbox is clicked', behaviorKey: 'onMouseClick'}
    ],

    'childFormColumn': [],

	'dateInputColumn': [
	    {text: 'Date Input changes field data', behaviorKey: 'onChanged'},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Date Input gains focus', behaviorKey: 'onFocus'},
        {text: 'Date Input loses focus', behaviorKey: 'onBlur'},
        {text: 'Date Input is clicked', behaviorKey: 'onMouseClick'}
    ],

	'dropdownColumn': [
	    {text: 'Drop-Down changes field data', behaviorKey: 'onChanged'},
        {text: 'Drop-Down gains focus', behaviorKey: 'onFocus'},
        {text: 'Drop-Down loses focus', behaviorKey: 'onBlur'},
        {text: 'Drop-Down is clicked', behaviorKey: 'onMouseClick'}
    ],

	'fileAttachmentColumn': [
	    {text: 'File Attachment changes field data', behaviorKey: 'onChanged'},
        {text: 'File Attachment is clicked', behaviorKey: 'onMouseClick'}
    ],

	'numericInputColumn': [
	    {text: 'Numeric Input changes field data', behaviorKey: 'onChanged'},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Numeric Input gains focus', behaviorKey: 'onFocus'},
        {text: 'Numeric Input loses focus', behaviorKey: 'onBlur'},
        {text: 'Numeric Input is clicked', behaviorKey: 'onMouseClick'}
    ],

	'radioButtonColumn': [
	    {text: 'Radio Button changes field data', behaviorKey: 'onChanged'},
        {text: 'Radio Button gains focus', behaviorKey: 'onFocus'},
        {text: 'Radio Button loses focus', behaviorKey: 'onBlur'},
        {text: 'Radio Button is clicked', behaviorKey: 'onMouseClick'}
    ],

	'textAreaColumn': [
	    {text: 'Text Area changes field data', behaviorKey: 'onChanged'},
        {text: 'Key is pressed', behaviorKey: 'onKeyPress'},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Text Area gains focus', behaviorKey: 'onFocus'},
        {text: 'Text Area loses focus', behaviorKey: 'onBlur'},
        {text: 'Text Area is clicked', behaviorKey: 'onMouseClick'}
    ],

	'textInputColumn': [
        {text: 'Text Input changes field data', behaviorKey: 'onChanged'},
        {text: 'Key is pressed', behaviorKey: 'onKeyPress'},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Text Input gains focus', behaviorKey: 'onFocus'},
        {text: 'Text Input loses focus', behaviorKey: 'onBlur'},
        {text: 'Text Input is clicked', behaviorKey: 'onMouseClick'}
    ],

	'timeInputColumn': [
	    {text: 'Time Input changes field data', behaviorKey: 'onChanged'},
        {text: 'Enter key is pressed', behaviorKey: 'onKeyPressEnter', mobileCompatible: true},
        {text: 'Time Input gains focus', behaviorKey: 'onFocus'},
        {text: 'Time Input loses focus', behaviorKey: 'onBlur'},
        {text: 'Time Input is clicked', behaviorKey: 'onMouseClick'}
    ],

    'control_ranking': [
        {text: 'Ranking changes field data', behaviorKey: 'onChanged', mobileCompatible: false},
        {text: 'Ranking gains focus', behaviorKey: 'onFocus', mobileCompatible: false},
        {text: 'Ranking loses focus', behaviorKey: 'onBlur', mobileCompatible: false},
        {text: 'Ranking is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Ranking is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],

    'asset': [],
    'control_bar_chart': [
        {text: 'Bar Chart is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Bar Chart is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_pie_chart': [
        {text: 'Pie Chart is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Pie Chart is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_line_chart': [
        {text: 'Line Chart is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Line Chart is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_data_grid': [
        {text: 'Data Grid is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Data Grid is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_data_list': [
        {text: 'Data List is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Data List is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_crosstab': [
        {text: 'Crosstab is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Crosstab is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_gauge_chart': [
        {text: 'Gauge is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Gauge is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_value': [
        {text: 'Value is clicked', behaviorKey: 'onMouseClick', mobileCompatible: false},
        {text: 'Value is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ],
    'control_filter_selector': [
        {text: 'Filter selector is shown', behaviorKey: 'onCreate', mobileCompatible: false}
    ]
};

const behaviorViews = {
    'connection_arrow': [{view: CustomBehaviorView, el: constants.PROP_BEHAVIOR_VIEW}]
}

class ObjectBehaviorMapService {
    constructor() {

        // Build immutable structure from raw object structure
        this._behaviorsMap = Immutable.Map(behaviors);
        this._customBehaviorsMap = Immutable.Map(behaviorViews);

    }

    getBehaviors(factoryKey) {
        const list = this._behaviorsMap.get(factoryKey, Immutable.List());
        return list;
    }

    getBehaviorViews(factoryKey) {
        const list = this._customBehaviorsMap.get(factoryKey, Immutable.List());
        return list;
    }
}

const objectBehaviorMapService = new ObjectBehaviorMapService();
export default objectBehaviorMapService;